import './contact-display-qualification.component.ajscss';

import { IContactEntry } from '@commons/models/contact-entry';
import { IChangesObject, IComponentController, IComponentOptions, isArray, isDefined } from 'angular';
import { i18n } from 'i18next';

import { MomentService } from '@contact/upgrade';

import templateUrl from './contact-display-qualification.component.ajs.html';

export class FormContent {
  key: string;
  value: string;
}

class FormFields {
  hasFields: boolean;
  action_label: string;
  fields: FormContent[];
  isOpen: boolean;
  entryDate: Date;
}

class ContactDisplayQualificationCtrl implements IComponentController {
  public panelTitle: string;
  // params
  currentContactList: IContactEntry[];

  // the object displayed in the html
  currentFormFields: FormFields[];

  constructor(private readonly $i18next: i18n, private readonly timeUtil: MomentService) {}

  $onInit(): void {
    this.refreshContents();
  }

  $onChanges(onChangesObj: { [property: string]: IChangesObject }): void {
    this.currentContactList = onChangesObj['currentContactList'].currentValue;
    // this.$log.debug("[contactDisplayQualificationView] current postQualif [" + JSON.stringify(this.currentContact) + "]");
    this.refreshContents();
  }

  refreshContents(): void {
    this.currentFormFields = [];
    let translationName = 'agent:contact.workspace.' + this.currentContactList[0].canalName.toLowerCase() + '.qualification.title';
    this.panelTitle = this.$i18next.t(translationName);
    if (this.panelTitle === translationName) {
      this.panelTitle = this.$i18next.t('agent:contact.info.popin.qualification.title');
    }
    if (isDefined(this.currentContactList)) {
      this.currentContactList.forEach((currentContact: IContactEntry) => {
        let myfields: FormContent[] = this.getFields(currentContact);
        if (currentContact.csrFirstname && currentContact.csrLastname) {
          this.currentFormFields.push({
            hasFields: myfields.length > 0,
            action_label: currentContact.csrFirstname + ' ' + currentContact.csrLastname,
            fields: myfields,
            isOpen: false,
            entryDate: currentContact.beginDate,
          });
        }
      });
      if (this.currentFormFields.length > 0) {
        this.currentFormFields.sort((a, b) =>
          new Date(a.entryDate) > new Date(b.entryDate) ? -1 : new Date(a.entryDate) < new Date(b.entryDate) ? 1 : 0
        );
        this.currentFormFields[0].isOpen = true;
      }
    }
  }

  getFields(_currentContact: IContactEntry): FormContent[] {
    let myContents: FormContent[] = [];
    if (isDefined(_currentContact) && _currentContact.canalName !== 'SMS' && _currentContact.canalName !== 'CHAT_IADVIZE') {
      if (isDefined(_currentContact) && isDefined(_currentContact.contents) && isArray(_currentContact.contents)) {
        _currentContact.contents.forEach(element => {
          if (isDefined(element.content) && element.contentType === 'FORM') {
            myContents = myContents.concat(JSON.parse(element.content));
          }
        });
      }
    }
    return myContents;
  }

  readableDateTime(dateToConvert: Date): string {
    return this.timeUtil.readableDateTime(dateToConvert);
  }
}

export class ContactDisplayQualification implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    currentContactList: '<',
  };
  controller = ['$i18next', 'momentService', ContactDisplayQualificationCtrl];
}

export default 'contactDisplayQualificationView';
